// extracted by mini-css-extract-plugin
export var chip = "_me-2";
export var chipBody = "_me-8";
export var chipHeader = "_me-9";
export var chipWithKind = "_me-7";
export var icon = "_me-3";
export var kind = "_me-a";
export var remove = "_me-5";
export var removeIcon = "_me-6";
export var row = "_me-0";
export var rowHistorical = "_me-1";
export var text = "_me-4";